import { render, staticRenderFns } from "./CustomService.vue?vue&type=template&id=42106aa4&scoped=true"
import script from "./CustomService.vue?vue&type=script&lang=js"
export * from "./CustomService.vue?vue&type=script&lang=js"
import style0 from "./CustomService.vue?vue&type=style&index=0&id=42106aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42106aa4",
  null
  
)

export default component.exports